const QueryKeyFactory = {
  cms: {
    whatsNew: () => ['cms', 'whatsNew'],
  },
} as const;

export { QueryKeyFactory, QueryKeyFactory as QK };
